@import '../../shared';

.form-textarea {
  &__container {
    position: relative;
  }

  &__control {
    @include form-component;
    width: 100%;
    font-size: inherit;
    border-radius: $border-radius-small;
    padding: 1.2rem 3.2rem 1.2rem 1.2rem;
    margin-bottom: 1.5rem;
    display: block;
    resize: vertical;
  
    &:focus {
      outline: none;
      border-color: $blue;
    }
  }

  &--disabled {
    .form-textarea__control {
      @include form-component-disabled;
    }
  }

  &--accept {
    .form-textarea__control {
      border-color: $green-border;
      &:focus {
        outline: none;
        border-color: $green-border;
      }
    }
    .form-textarea__icon {
      fill: $green;
    }
  }

  &--reject {
    .form-textarea__control {
      border-color: $red-border;
      &:focus {
        outline: none;
        border-color: $red-border;
      }
    }
    .form-textarea__icon {
      fill: $red;
    }
  }
  
  &__icon {
    position: absolute;
    top: 1rem;
    right: 0.8rem;
  }

  &__limit {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 1.5rem;
  }
}
